var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type() === 'detailed')?_c('drivers-periods-available-overview-detailed'):_vm._e(),(_vm.type() === 'simple')?_c('drivers-periods-available-overview-simple'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }